import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { adminContenidoMicroaprendizajes, adminMicroaprendizajes, getContenidoMicroaprendizajes, getMicroaprendizajes } from "Services/microaprendizaje_service";
import { fileUri } from "Constantes/constants";
import { uploadFile } from "Services/file_service";
import { getPlantilla } from "Services/meta_service";

const initialState = {
    microaprendizajes: [],
    microaprendizaje: {
        idMicroaprendizaje: null,
        idEstructuraCurso: -1,
        codigo: "",
        orden: 0,
        idCurso: -1,
        titulo: "",
        descripcion: "",
        estado: 1
    },
    contenidoSeleccionadoMicroaprendizaje: {
        idContenidoMicroaprendizaje: 0,
        titulo: '',
        archivo: '',
        orden: 0,
        idTipoContenido: 0,
        tipoContenido: '',
        formato: '',
        idMicroaprendizaje: 0,
        estado: 1,
    },
    tipoContenido: [],
    tipoContenidoSeleccionado: {
        titulo: '',
        idTipoContenido: 0,
        nombre: '',
        formato: '',
        estado: 1,
    },
    contenidoMicroaprendizaje: [],
}

export const microaprendizajeSlice = createSlice({
    name: 'microaprendizaje',
    initialState,
    reducers: {
        setMicroaprendizajes: (state, action) => {
            state.microaprendizajes = action.payload;
        },
        setMicroaprendizaje: (state, action) => {
            state.microaprendizaje = action.payload ?? initialState.microaprendizaje;
        },
        setContenidoSeleccionadoMicroaprendizaje: (state, action) => {
            state.contenidoSeleccionadoMicroaprendizaje = action.payload;
        },
        setContenidoMicroaprendizaje: (state, action) => {
            state.contenidoMicroaprendizaje = action.payload;
        }
    }
});

export const fetchMicroaprendizaje = createAsyncThunk(
    'microaprendizaje/fetchMicroaprendizaje',
    async (data, { dispatch }) => {
        const microaprendizajeRes = await getMicroaprendizajes(data);
        dispatch(setMicroaprendizajes(microaprendizajeRes));
    }
);

// export const fetchContenidoMicroaprendizaje = createAsyncThunk(
//     'microaprendizaje/fetchContenidoMicroaprendizaje',
//     async (data, { dispatch }) => {
//         const contenidoMicroaprendizajeRes = await getContenidoMicroaprendizajes(data);
//         dispatch(setContenidoMicroaprendizaje(contenidoMicroaprendizajeRes));
//     }
// );

export const fetchContenidoMicroaprendizaje = createAsyncThunk(
    "microaprendizaje/fetchContenidoMicroaprendizaje",
    async (data, { dispatch }) => {
        const res = await getContenidoMicroaprendizajes(data);
        const items = Array.isArray(res) ? res : [];

        const ids = [
            ...new Set(
                items
                    .filter((x) => x?.formato === ".plantilla" && Number(x?.archivo) > 0)
                    .map((x) => Number(x.archivo))
            ),
        ];

        const detalles = await Promise.all(
            ids.map(id =>
                getPlantilla({ idPlantilla: id })
                    .then(res => {
                        return Array.isArray(res) ? res[0] : res; // devuelve el obj
                    })
                    .catch(() => null)
            )
        );

        const byId = new Map();
        detalles.forEach((d) => {
            if (d && Number(d.idPlantilla) > 0) {
                byId.set(Number(d.idPlantilla), d);
            }
        });

        const enriched = items.map((it) =>
            it?.formato === ".plantilla" && Number(it?.archivo) > 0
                ? { ...it, plantilla: byId.get(Number(it.archivo)) || null }
                : it
        );

        dispatch(setContenidoMicroaprendizaje(enriched));
    }
);

export const mergeMicroaprendizaje = createAsyncThunk(
    'microaprendizaje/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const microaprendizajeRes = await adminMicroaprendizajes(data);
        dispatch(setResponse(microaprendizajeRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchMicroaprendizaje({ idCurso: null }));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

const isRealFile = (f) => (typeof File !== 'undefined' && f instanceof File) ||
                          (typeof Blob !== 'undefined' && f instanceof Blob);

const loadFile = async (file, type, id) => {
  if (!isRealFile(file)) {
    console.warn('No hay archivo real que subir:', file);
    return null;
  }
  const fd = new FormData();
  fd.append('file', file, file.name || 'upload.bin'); // clave exacta: "file"
  fd.append('type', type);
  fd.append('ID', String(id));

  return uploadFile(fd);
};

export const mergeContenidoMicroaprendizaje = createAsyncThunk(
  'microaprendizaje/mergeContenido',
  async (data, { dispatch }) => {
    dispatch(setLoading(true));

    data.archivo = data.idEncuesta > 0 ? data.idEncuesta : data.archivo;

    if (isRealFile(data?.file)) {
      await loadFile(data.file, fileUri.microaprendizaje, data.idMicroaprendizaje);
    }

    const contenidoMicroaprendizajeRes = await adminContenidoMicroaprendizajes(data);

    await dispatch(fetchContenidoMicroaprendizaje({ idMicroaprendizaje: data.idMicroaprendizaje }));
    dispatch(setResponse(contenidoMicroaprendizajeRes));
    dispatch(setLoading(false));
    dispatch(setModal(false));
    dispatch(setToast(true));
    setTimeout(() => dispatch(setToast(false)), 3000);
  }
);


export const { setMicroaprendizajes, setMicroaprendizaje, setContenidoSeleccionadoMicroaprendizaje, setContenidoMicroaprendizaje } = microaprendizajeSlice.actions;
export default microaprendizajeSlice.reducer;